// Shared design tokens. Values intentionally point at CSS custom properties so
// changing the global theme updates inline-style based pages without a reload.
export const T = {
    bg: 'var(--admin-bg)',
    sidebarBg: 'var(--admin-surface)',
    border: 'var(--admin-border)',
    borderStrong: 'var(--admin-border-strong)',
    textPrimary: 'var(--admin-text)',
    textSecondary: 'var(--admin-text-secondary)',
    textMuted: 'var(--admin-text-muted)',
    primary: 'var(--admin-primary)',
    primaryLight: 'var(--admin-primary-light)',
    primaryPale: 'var(--admin-primary-soft)',
    success: '#10B981',
    successBg: '#ECFDF5',
    successText: '#059669',
    danger: '#EF4444',
    dangerBg: '#FEF2F2',
    dangerText: '#DC2626',
    cardBg: 'var(--admin-surface)',
    cardShadow: 'var(--admin-shadow)',
    iconBadgeBg: 'var(--admin-surface-muted)',
    radius: '14px',
};
